import axios from 'axios';

// DB에서 검색
export const searchFromDatabase = async (query, city) => {
  try {
    console.log('🔍 DB 검색:', query);
    
    const response = await axios.get(`/api/search/db`, {
      params: { q: query, city: city }
    });

    console.log('✅ DB 검색 결과:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ DB 검색 오류:', error);
    throw error;
  }
};

// API 사용량 조회
export const getApiUsage = async () => {
  try {
    console.log('📊 API 사용량 조회');
    
    const response = await axios.get(`/api/search/api-usage`);
    
    console.log('✅ API 사용량:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ API 사용량 조회 오류:', error);
    // 기본값 반환
    return {
      callCount: 0,
      dailyLimit: 300,
      remainingCalls: 300
    };
  }
};

// API 호출 가능 여부 체크
export const canCallApi = async () => {
  try {
    const response = await axios.get(`/api/search/can-call-api`);
    return response.data;
  } catch (error) {
    console.error('❌ API 호출 가능 여부 체크 오류:', error);
    throw error;
  }
};

// API 카운터 증가
export const incrementApiCounter = async () => {
  try {
    const response = await axios.post(`/api/search/increment-counter`);
    return response.data;
  } catch (error) {
    console.error('❌ API 카운터 증가 오류:', error);
    throw error;
  }
};

// 맛집 저장
export const saveRestaurant = async (placeData) => {
  try {
    const dto = {
      name: placeData.name,
      address: placeData.address,
      lat: placeData.location?.latitude || placeData.latitude,
      lng: placeData.location?.longitude || placeData.longitude,
      rating: placeData.rating,
      memo: placeData.memo || '',
      category: placeData.priceLevel || '',
      city: '서울',
    };

    const response = await axios.post(`/api/restaurants`, dto);
    return response.data;
  } catch (error) {
    console.error('❌ 맛집 저장 오류:', error);
    throw error;
  }
};
